
export const fieldsConfig = [
  {
    name: "name",
    label: "Business Type",
    type: "text",
    required: true,
  },
];
